
import { useTranslation } from 'react-i18next';

const OffersGrid = () => {
    const { t } = useTranslation();
    return (
        <>
            <h2 className="text-center h3">Ofertas generales</h2>
            <div className="o-cont-fullw">
                <div className="container">
                    <div className="cc-offer-swiper">
                        <swiper-container init="false" style={{ display: "flex" }}>
                            <div className="c-card c-card-oferta" style={{ marginRight: "16px" }} role="group" aria-label="1 / 5">
                                <div className="position-relative">
                                    <figure className="c-card_img">
                                        <img className="img" src="https://pro-static.h10hotels.com/gallery/T11D3/29_ORPSwimUpBar1.jpg" alt="Swim Up Bar" />
                                    </figure>
                                    <div className="c-card-oferta_text">
                                        <p>
                                            <strong>El lujo de disfrutar juntos</strong>
                                        </p>
                                    </div>
                                </div>
                                <button tabIndex="0" className="btn btn-link"> Ver detalles <span className="o-icon arrow">
                                    <i className="fa-solid fa-arrow-right"></i>
                                </span>
                                </button>
                            </div>
                            <div className="c-card c-card-oferta" style={{ marginRight: "16px" }} role="group" aria-label="2 / 5">
                                <div className="position-relative">
                                    <figure className="c-card_img">
                                        <img className="img" src="https://pro-static.h10hotels.com/gallery/T11D3/22.3_HPAPool4.jpg" alt="Plunge pool &amp; Solarium" />
                                    </figure>
                                    <div className="c-card-oferta_text">
                                        <p>

                                            <strong>La esencia de lo inolvidable en The One</strong>

                                        </p>
                                    </div>
                                </div>
                                <button tabIndex="0" className="btn btn-link"> Ver detalles <span className="o-icon arrow">
                                    <i className="fa-solid fa-arrow-right"></i>
                                </span>
                                </button>
                            </div>
                            <div className="c-card c-card-oferta" style={{ marginRight: "16px" }} role="group" aria-label="3 / 5">
                                <div className="position-relative">
                                    <figure className="c-card_img">
                                        <img className="img" src="https://pro-static.h10hotels.com/gallery/T11D3/07.1_HMVHotelPool.jpg" alt="Piscina" />
                                    </figure>
                                    <div className="c-card-oferta_text">
                                        <p>

                                            <strong>Salou y Cambrils: la esencia mediterránea</strong>

                                        </p>
                                    </div>
                                </div>
                                <button tabIndex="0" className="btn btn-link"> Ver detalles <span className="o-icon arrow">
                                    <i className="fa-solid fa-arrow-right"></i>
                                </span>
                                </button>
                            </div>
                            <div className="c-card c-card-oferta" style={{ marginRight: "16px" }} role="group" aria-label="4 / 5">
                                <div className="position-relative">
                                    <figure className="c-card_img">
                                        <img className="img" src="https://pro-static.h10hotels.com/gallery/T11D3/12.3_HAGBreakfast3.jpg" alt="Restaurante Modern Art" />
                                    </figure>
                                    <div className="c-card-oferta_text">
                                        <p>

                                            <strong>Dto. para tu desayuno en una selección de hoteles</strong>

                                        </p>
                                    </div>
                                </div>
                                <button tabIndex="0" className="btn btn-link"> Ver detalles <span className="o-icon arrow">
                                    <i className="fa-solid fa-arrow-right"></i>
                                </span>
                                </button>
                            </div>
                            <div className="c-card c-card-oferta" style={{ marginRight: "16px" }} role="group" aria-label="5 / 5">
                                <div className="position-relative">
                                    <figure className="c-card_img">
                                        <img className="img" src="https://pro-static.h10hotels.com/gallery/T11D3/OEB_Traslados.jpg" alt="" />
                                    </figure>
                                    <div className="c-card-oferta_text">
                                        <p>

                                            <strong>Transfer gratis en el Caribe</strong>

                                        </p>
                                    </div>
                                </div>
                                <button tabIndex="0" className="btn btn-link"> Ver detalles <span className="o-icon arrow">
                                    <i className="fa-solid fa-arrow-right"></i>
                                </span>
                                </button>
                            </div>
                        </swiper-container>
                    </div>
                </div>
            </div>
        </>
    );
}
export default OffersGrid;
